import React from 'react'

import TableModel from 'models/TableModel'

const LibraryTableCell = (props) => {
  const header = TableModel[props.classname].headers.find(header => header.field === props.field)
  return (
    <td className={`table-cell table-cell-${props.classname} table-cell-size-${props.size} table-cell-library-action`}>
      <div onClick={(e)=>props.libraryAction(`${header.libraryAction}${encodeURI(props.datum)}`,e)}>
        {props.datum}
      </div>
    </td>
  )
}

export default LibraryTableCell